/**
 * /tenants/$slug/authentication/enrollment-issuers — Enrollment issuers tab of
 * the Authentication hub (platform-admin only). Thin route shim; domain logic
 * lives in features/trusted-enrollment-issuers/.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchTrustedEnrollmentIssuers } from "@/features/trusted-enrollment-issuers/queries";
import { TrustedEnrollmentIssuersPage } from "@/features/trusted-enrollment-issuers/pages/trusted-enrollment-issuers-page";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/authentication/enrollment-issuers",
)({
  loader: async ({ context }) => {
    // Platform-admin-only endpoint: swallow a prefetch failure (e.g. a
    // non-platform-admin deep-linking here) so the page can render its own
    // "platform admin required" gate instead of the route error boundary. The
    // component's query re-runs and surfaces real errors for platform admins.
    try {
      await context.queryClient.ensureQueryData({
        queryKey: queryKeys.trustedEnrollmentIssuers.list(context.tenant.id),
        queryFn: () => fetchTrustedEnrollmentIssuers(context.tenant.id),
      });
    } catch {
      // no-op — handled in the page component
    }
    return null;
  },
  component: TrustedEnrollmentIssuersPage,
});
